import type { routeUtil } from '@cmg/common';

import routeFactory from '../../../common/util/routeFactory';

type RouteName =
  | 'crmManagement'
  | 'crmInvestorFirms'
  | 'crmInvestorFirmsNew'
  | 'crmInvestorFirm'
  | 'crmInvestorFirmSalesCoverageGrid'
  | 'crmInvestorFirmInvestorContactsGrid'
  | 'crmSalesCoverage'
  | 'crmSalesCoverageEmployee'
  | 'crmSalesCoverageEmployeeNew'
  | 'crmFilesUpload';

export const sysAdminCrmRoutes = {
  crmManagement: routeFactory.sysAdminCrmManagement,
  crmInvestorFirms: routeFactory.sysAdminCrmInvestorFirms,
  crmInvestorFirmsNew: routeFactory.sysAdminCrmInvestorFirmsNew,
  crmInvestorFirm: routeFactory.sysAdminCrmInvestorFirm,
  crmInvestorFirmSalesCoverageGrid: routeFactory.sysAdminCrmInvestorFirmSalesCoverageGrid,
  crmInvestorFirmInvestorContactsGrid: routeFactory.sysAdminCrmInvestorFirmInvestorContactsGrid,
  crmSalesCoverage: routeFactory.sysAdminCrmSalesCoverage,
  crmSalesCoverageEmployee: routeFactory.sysAdminCrmSalesCoverageEmployee,
  crmSalesCoverageEmployeeNew: routeFactory.sysAdminCrmSalesCoverageEmployeeNew,
  crmFilesUpload: routeFactory.sysAdminCrmFilesUpload,
} satisfies Record<RouteName, ReturnType<typeof routeUtil.createRoute>>;

export const customerCrmRoutes = {
  crmManagement: routeFactory.customerCrmManagement,
  crmInvestorFirms: routeFactory.customerCrmInvestorFirms,
  crmInvestorFirmsNew: routeFactory.customerCrmInvestorFirmsNew,
  crmInvestorFirm: routeFactory.customerCrmInvestorFirm,
  crmInvestorFirmSalesCoverageGrid: routeFactory.customerCrmInvestorFirmSalesCoverageGrid,
  crmInvestorFirmInvestorContactsGrid: routeFactory.customerCrmInvestorFirmInvestorContactsGrid,
  crmSalesCoverage: routeFactory.customerCrmSalesCoverage,
  crmSalesCoverageEmployee: routeFactory.customerCrmSalesCoverageEmployee,
  crmSalesCoverageEmployeeNew: routeFactory.customerCrmSalesCoverageEmployeeNew,
  crmFilesUpload: routeFactory.customerCrmFilesUpload,
} satisfies Record<RouteName, ReturnType<typeof routeUtil.createRoute>>;
